<script setup>
/** 一段可以一键复制的文字（接入 prompt 等）。浏览器不许写剪贴板时退而选中文字，让人自己按复制键。 */
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Button } from '@drama/ui'

defineProps({ text: { type: String, required: true } })

const { t } = useI18n()
/** 'idle' | 'copied' | 'selected' */
const copyState = ref('idle')
const block = ref(null)

async function copy() {
  try {
    await navigator.clipboard.writeText(block.value.textContent)
    copyState.value = 'copied'
  } catch (error) {
    // 剪贴板是浏览器给的外部能力：没授权（如内嵌浏览器、非安全上下文）时选中整段，提示按键复制。
    if (error.name !== 'NotAllowedError') throw error
    window.getSelection().selectAllChildren(block.value)
    copyState.value = 'selected'
  }
  setTimeout(() => { copyState.value = 'idle' }, 4000)
}
</script>

<template>
  <div class="voko-copy">
    <pre><code ref="block">{{ text }}</code></pre>
    <Button size="sm" @click="copy">{{ copyState === 'copied' ? t('join.copied') : t('join.copy') }}</Button>
  </div>
  <p v-if="copyState === 'selected'" class="voko-muted">{{ t('join.selected') }}</p>
  <p class="voko-visually-hidden" aria-live="polite">{{ copyState === 'copied' ? t('join.copied') : copyState === 'selected' ? t('join.selected') : '' }}</p>
</template>

<style scoped>
.voko-copy {
  display: flex;
  align-items: flex-start;
  gap: var(--drama-space-sm);
}
.voko-copy pre {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: var(--drama-space-md);
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: var(--drama-font-family-mono);
  font-size: var(--drama-font-size-sm);
  background: var(--drama-color-surface-alt);
  border: 1px solid var(--drama-color-border);
  border-radius: var(--drama-radius-md);
}
.voko-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
